import { render, staticRenderFns } from "./CustomerApproved.vue?vue&type=template&id=03d80b2f&scoped=true&"
import script from "./CustomerApproved.vue?vue&type=script&lang=js&"
export * from "./CustomerApproved.vue?vue&type=script&lang=js&"
import style0 from "./CustomerApproved.vue?vue&type=style&index=0&id=03d80b2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d80b2f",
  null
  
)

export default component.exports